import { ChangeDetectionStrategy, Component } from '@angular/core';

type InspectionStatus = 'on-track' | 'needs-review' | 'flagged' | 'pending';
type ConditionRating = 'good' | 'fair' | 'poor' | 'none';

interface InspectionRow {
  site: string;
  condition: ConditionRating;
  conditionLabel: string;
  captured: string;
}

@Component({
  selector: 'app-home-ai-insights-section',
  standalone: true,
  templateUrl: './home-ai-insights-section.component.html',
  styleUrl: './home-ai-insights-section.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeAiInsightsSectionComponent {
  readonly inspectionPhotos = [
    'assets/images/landing/insight-1.webp',
    'assets/images/landing/insight-2.webp',
    'assets/images/landing/insight-3.webp',
    'assets/images/landing/insight-4.webp'
  ];

  readonly inspectionRows: InspectionRow[] = [
    {
      site: 'Pipe Rack 7',
      condition: 'fair',
      conditionLabel: 'Fair',
      captured: '3 photos · GPS logged'
    },
    {
      site: 'Turbine Bay A',
      condition: 'good',
      conditionLabel: 'Good',
      captured: '4 photos · GPS logged'
    },
    {
      site: 'Storage Yard',
      condition: 'poor',
      conditionLabel: 'Poor',
      captured: '2 photos · GPS logged'
    },
    {
      site: 'Cooling Tower 2',
      condition: 'good',
      conditionLabel: 'Good',
      captured: '6 photos · GPS logged'
    },
  ];

  statusBadgeClass(status: InspectionStatus): string {
    switch (status) {
      case 'on-track':
        return 'bg-success-100 text-success-800';
      case 'needs-review':
        return 'bg-warn-100 text-warn-800';
      case 'flagged':
        return 'bg-error-100 text-error-800';
      case 'pending':
        return 'bg-slate-100 text-slate-600';
    }
  }

  conditionTextClass(condition: ConditionRating): string {
    switch (condition) {
      case 'good':
        return 'text-success-700';
      case 'fair':
        return 'text-warn-700';
      case 'poor':
        return 'text-error-700';
      case 'none':
        return 'text-slate-400';
    }
  }
}
